/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {McpServiceAccount} from '../models/McpServiceAccount';

export interface GetAccountMcpServiceAccount$Request {
    accountId: number;
}

export interface GetAccountMcpServiceAccount$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getAccountMcpServiceAccountRequest = createAction<PayloadData<void, GetAccountMcpServiceAccount$Request>>('GET_ACCOUNT_MCP_SERVICE_ACCOUNT__GET_ACCOUNT_MCP_SERVICE_ACCOUNT__REQUEST');
export const getAccountMcpServiceAccountSuccess = createAction<PayloadData<McpServiceAccount, GetAccountMcpServiceAccount$Request>>('GET_ACCOUNT_MCP_SERVICE_ACCOUNT__GET_ACCOUNT_MCP_SERVICE_ACCOUNT__SUCCESS');
export const getAccountMcpServiceAccountFailure = createAction<PayloadData<Error, GetAccountMcpServiceAccount$Request, true>>('GET_ACCOUNT_MCP_SERVICE_ACCOUNT__GET_ACCOUNT_MCP_SERVICE_ACCOUNT__FAILURE');

export const getAccountMcpServiceAccountActions = [
    getAccountMcpServiceAccountRequest,
    getAccountMcpServiceAccountSuccess,
    getAccountMcpServiceAccountFailure
] as const;

/**
 * @param {number} meta.accountId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getAccountMcpServiceAccount = (meta: GetAccountMcpServiceAccount$Request, config?: GetAccountMcpServiceAccount$Config) => {
    return {
        CALL_API: {
            types: getAccountMcpServiceAccountActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/accounts/${meta.accountId}/mcp/settings`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

